module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv11-619a464695805e8cc43b3e7fb96ec998.jpg";